import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

// permissiom judge
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin权限 直接通过
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

const whiteList = ['/login','/register','/forget'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();
  // console.log(getToken())
  if (getToken()) {
    // next()

    // store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
    //   router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
    //   next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a history record
    // })
    // next()

    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    } else {

      if (store.getters.roles == '') { // 判断当前用户是否已拉取完user_info信息
        // debugger;
        store.dispatch('GetInfo').then(response => { // 拉取user_info
          const data = response.returnValue
          // 判断海内海外
          let areaType
          let locationPath = window.location.href
          let reg = RegExp(/overseas/)
          areaType = reg.test(locationPath) ? 1 : 0
          localStorage.setItem('areaType', areaType);
          localStorage.setItem('accountType', data.accountType);
          localStorage.setItem('LJ_sp', data.scanPrice);
          // debugger;
          store.dispatch('GenerateRoutes', data).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a history record
          }).catch(()=>{

          })
        }).catch(() => {
          store.dispatch('FedLogOut').then(() => {
            Message.error('验证失败,请重新登录')
            next({ path: '/login' })
          })
        })
      } else {
        next()
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // if (hasPermission(store.getters.roles, to.meta.role)) {
        //   next()//
        // } else {
        //   next({ path: '/401', query: { noGoBack: true }})
        //   NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
        // }
        // 可删 ↑
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})
router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js